import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledResultsSectionContainer = styled.div`
  width: 100%;
  flex-direction: column;
  @media screen and (min-width: ${Breakpoints.b960}px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 60px;
    row-gap: 30px;
  }
`;

export const StyledResultWrapper = styled.div`
  width: 100%;
  padding-bottom: 20px;
  @media screen and (min-width: ${Breakpoints.b960}px) {
    width: calc((100% - 120px) / 3);
    padding: 0;
  }
`;
